import cc from 'store/util/createReduxConstant';
import { createRequestConstantNames } from 'store/util/createConstants';

export const [
  GET_BANK_ACCOUNT_INFO,
  GET_BANK_ACCOUNT_INFO_SUCCESS,
  GET_BANK_ACCOUNT_INFO_FAIL,
] = createRequestConstantNames(cc('GET_BANK_ACCOUNT_INFO'));
